import React from 'react';

export const ArrowForward = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <path stroke="#72706F" strokeLinecap="round" strokeLinejoin="round" d="m9.6 16.8 4.8-4.8-4.8-4.8" />
      </g>
    </svg>
  );
};

export default ArrowForward;
